import { conformToMask } from 'react-text-mask';

import { phoneMask } from './validationUtils';
import { isNil } from 'lodash';

export const getMaskedNumberValue = (
  value?: string,
  mask: (string | RegExp)[] = phoneMask,
) => {
  return value ? conformToMask(value, mask, {}).conformedValue : '';
};

export const getSecureNumberValue = (
  value?: string,
  securePrefixLength: number = 0,
  secureChar: string = '•',
  maxVisibleLength: number = 4,
) => {
  if (!value) return '';

  value = value.replace(/\r?\n|\r/g, ''); // Remove newlines

  const lastCharacters = value.substr(maxVisibleLength * -1);
  const securePrefix = secureChar.repeat(securePrefixLength);

  return `${securePrefix} ${lastCharacters}`;
};

interface NumberFormatter {
  separator: string;
  toFixed?: number;
}

const defaultNumberFormetterOptions: NumberFormatter = {
  separator: ',',
  toFixed: 2,
};

export const getFormattedNumber = (
  num: number | undefined,
  options: Partial<NumberFormatter> = defaultNumberFormetterOptions,
) => {
  if (isNil(num)) return;

  const { separator = defaultNumberFormetterOptions.separator, toFixed = 2 } =
    options;

  return num
    .toFixed(toFixed)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};

interface CurrencyFormattingOptions {
  num?: number;
  symbol?: string;
  options?: Partial<NumberFormatter>;
  isRightSymbol?: boolean;
}

export const formatNumberAsCurrency = ({
  num,
  isRightSymbol = true,
  symbol = '$',
  options = defaultNumberFormetterOptions,
}: CurrencyFormattingOptions) => {
  if (isNil(num)) return;

  const formattedNumber = getFormattedNumber(num, options);

  return isRightSymbol
    ? `${symbol}${formattedNumber}`
    : `${formattedNumber}${symbol}`;
};
